import React, { useLayoutEffect, useRef } from "react";
import TextArea from "@leafygreen-ui/text-area";

// LeafyGreen TextArea that starts taller and grows to fit its content,
// while remaining manually resizable. Height is content-driven with a
// floor of `minHeight`.
export default function AutoGrowTextArea({ minHeight = 180, value, style, className, ...props }) {
  const wrapperRef = useRef(null);

  const resize = () => {
    const el = wrapperRef.current && wrapperRef.current.querySelector("textarea");
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.max(el.scrollHeight, minHeight)}px`;
  };

  // Re-fit on value changes (typing and async prefill in edit/clone mode).
  useLayoutEffect(() => {
    resize();
  }, [value]);

  return (
    <div ref={wrapperRef} onInput={resize} className={className}>
      <TextArea
        value={value}
        style={{ minHeight: `${minHeight}px`, resize: "vertical", ...style }}
        {...props}
      />
    </div>
  );
}
